import { render, staticRenderFns } from "./main_list.vue?vue&type=template&id=7999b852&"
import script from "./main_list.vue?vue&type=script&lang=js&"
export * from "./main_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7999b852')) {
      api.createRecord('7999b852', component.options)
    } else {
      api.reload('7999b852', component.options)
    }
    module.hot.accept("./main_list.vue?vue&type=template&id=7999b852&", function () {
      api.rerender('7999b852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/form/main_list.vue"
export default component.exports